import { Component, Input, OnInit } from '@angular/core';
import { KeyValue } from '@angular/common';
import { LoincObjectGroup } from '../../../../../shared/services/loinc.service';

@Component({
  selector: 'app-loinc-detail-display',
  templateUrl: './loinc-detail-display.component.html',
  styleUrls: ['./loinc-detail-display.component.scss']
})
export class LoincDetailDisplayComponent implements OnInit {
  @Input() result: LoincObjectGroup = {};
  @Input() feedbackURL: string = '';

  language: string = localStorage.getItem('lang') ?? 'vi';

  constructor() {}

  ngOnInit(): void {
    if (this.result && this.result.hasOwnProperty('id')) {
      // @ts-ignore
      delete this.result['id'];
    }
  }

  originalOrder = (a: KeyValue<any,any>, b: KeyValue<any,any>): number => {
    return 0;
  }
}
